import { gql } from "@apollo/client";

import performanceAssessmentChartLabelQuestionFragment from "./performance-assessment-chart-label-question-fragment";

export default gql`
  ${performanceAssessmentChartLabelQuestionFragment}
  mutation savePerfAssessmentLabel(
    $organizationId: Int!
    $labels: [PerformanceAssessmentChartLabelInput]!
  ) {
    createOrUpdatePerformanceAssessmentChartLabel(
      organizationId: $organizationId
      labels: $labels
    ) {
      performanceAssessmentChartLabels {
        id
        label
        questionOne {
          ...PerformanceAssessmentChartLabelQuestion
        }
        questionTwo {
          ...PerformanceAssessmentChartLabelQuestion
        }
        questionOneIntegerAnswer
        questionTwoIntegerAnswer
      }
    }
  }
`;
